import ImportTemplateView from './ImportTemplateView'
export default ImportTemplateView;